import { BiltyFormat1, BiltyFormat2, BiltyFormat3 } from "BiltyFomates";
import { getBuiltyPrint, getMasterData } from "_services";
import { CommonModal, CustomSelect } from "components";
import { UserContext } from "context";
import { API, AppConfig } from "lib";
import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import StorageService from "utils/StorageServices/StorageServices";
import Loading from "pages/Loading";
import { Images } from "constants";
import { StorageServices } from "utils";
import { getAllLrFormatebyBranch } from "_services/accountsServices/branchServices";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { getPdfInvoiceBillRaise } from "_services/invoiceBillRaiseServices";

const InvoicePrintModal = (props) => {

    const { id } = useParams();
    const { invoiceFormats } = props;
    const [loading, setLoading] = useState(false);
    const [loadingBilty, setLoadingBilty] = useState(false)
    const [formats, setFormats] = useState({});
    let isToken = localStorage.getItem("token");
    const [buityFormatePreview, setBuityFormatePreview] = useState('')
    const [isLoaddingPrint, setIsLoaddingPrint] = useState(false);
    const [isLoaddingXlsx, setIsLoaddingXlsx] = useState(false);
    const [formatList, setFormatList] = useState([])
    const companyId = StorageServices.getCompanyId()

    const getBuiltyPrintapi = async () => {
        setLoadingBilty(true)
        try {
            const formate = {
                company_id: StorageService?.getCompanyId(),
                billraise_id: id,
                formatId: formats?.value,
            }
            const res = await getPdfInvoiceBillRaise(formate);
            setBuityFormatePreview(res)
            if (res) {
                setLoadingBilty(false)
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handlePrintDownload = async () => {
        const url = `${AppConfig.api_baseurl}${API.GET_PDF_LR_BILL_RAISE}/${StorageService?.getCompanyId()}/${id}/${formats?.value}`;
        try {
            setLoading(true);

            const response = await fetch(url, {
                headers: {
                    'Token': `${isToken}`,// if needed
                },
            });
            if (!response.ok) {
                const errorBody = await response.json().catch(() => ({}));
                if (errorBody?.responseMessage) {
                    toast.error(errorBody?.responseMessage);
                }
                throw new Error(`Server Error (${errorBody?.responseMessage})`);
            }

            const blob = await response.blob();
            const blobURL = URL.createObjectURL(blob);

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = blobURL;

            iframe.onload = function () {
                setTimeout(() => {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                }, 300);
            };

            document.body.appendChild(iframe);
            setLoading(false);
        } catch (error) {
            console.error('Print download failed:', error);
            setLoading(false);
        }
        // try {
        //     setLoading(true);
        //     const response = await fetch(`${AppConfig.api_baseurl}${API.GET_PDF_LR_BILL_RAISE}/${StorageService?.getCompanyId()}/${id}/${formats?.value}`, {
        //         headers: {
        //             'Token': `${isToken}`,
        //         },
        //     });

        //     if (!response.ok) {
        //         const errorBody = await response.json().catch(() => ({}));
        //         if (errorBody?.responseMessage) {
        //             toast.error(errorBody?.responseMessage);
        //         }
        //         throw new Error(`Server Error (${errorBody?.responseMessage})`);
        //     }

        //     const blob = await response.blob();
        //     const blobURL = URL.createObjectURL(blob);

        //     const iframe = document.createElement('iframe');
        //     iframe.style.display = 'none';
        //     iframe.src = blobURL;

        //     iframe.onload = function () {
        //         setTimeout(() => {
        //             iframe.contentWindow?.focus();
        //             iframe.contentWindow?.print();
        //         }, 300);
        //     };

        //     document.body.appendChild(iframe);
        //     setLoading(false);
        // } catch (error) {
        //     console.error('Print download failed:', error);
        //     setLoading(false);
        // }
    };

    const handleDownload = async () => {
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                billraise_id: id,
                invoice_format: formats?.value,
            }
            setIsLoaddingXlsx(true)
            const response = await fetch(`${AppConfig.api_baseurl}${API.LR_EXCEL_REPORT}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorBody = await response.json().catch(() => ({}));
                if (errorBody?.responseMessage) {
                    toast.error(errorBody?.responseMessage);
                }
                throw new Error(`Server Error (${errorBody?.responseMessage})`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Invoice report.xlsx`;
            // a.download = `Format-${state?.formate}/${moment(new Date()).format("D MMM YYYY")}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setIsLoaddingXlsx(false)
        } catch (error) {
            if (error?.responseMessage) {
                toast.error(error?.responseMessage);
            }
            setIsLoaddingXlsx(false)
        }
    }

    useEffect(() => {
        if (formats?.value) {
            getBuiltyPrintapi(formats?.value);
        }
    }, [formats])

    useEffect(() => {
        let invoiceFormatDropdown = invoiceFormats?.company_id?.invoice_formats?.map((el) => {
            return {
                ...el,
                label: el?.name,
                value: el?._id
            }
        })
        if (invoiceFormatDropdown?.length === 0) {
            props?.closeModal()
            props?.confirmBox()
        }
        setFormatList(invoiceFormatDropdown);

        let data = invoiceFormatDropdown?.find((i) => i?.value === invoiceFormats?.consignor_id?.invoice_format_id)
        if (data?.label && data?.value) {
            setFormats(data);
        } else {
            setFormats(invoiceFormatDropdown[0]);
        }
    }, [invoiceFormats])

    const formatePrpsTrip = {
        buityFormatePreview: buityFormatePreview
    };

    const pdfDownloadHandler = async () => {
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                billraise_id: id,
                invoice_format: formats?.value,
            }
            setIsLoaddingPrint(true)
            const response = await fetch(`${AppConfig.api_baseurl}${API.DOWNLOAD_PDF}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `invoice.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setIsLoaddingPrint(false)
        } catch (error) {
            setIsLoaddingPrint(false)
        }
    };

    const propsBuiltyPrint = {
        ...props,
        onPrint: handleDownload,
        onSubmit: handlePrintDownload,
        pdfDownloadHandler: pdfDownloadHandler,
        isLoadding: loading,
        disabled: loading || loadingBilty || isLoaddingPrint || isLoaddingXlsx,
        isLoaddingPrint: isLoaddingPrint,
        isLoaddingXlsx: isLoaddingXlsx
    };

    return (
        <>
            <CommonModal {...propsBuiltyPrint}>
                <div className="bltyPrint_body">
                    <div className="bltyPrt_viewPage_bx" id="print-area">

                        {!loadingBilty ? <BiltyFormat3 {...formatePrpsTrip} /> : <div colSpan="100%" style={{ textAlign: "center", margin: "0 22rem", display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
                            <img className="_loadWidth" style={{ width: "150px", color: "f2f2f2" }} src={Images.LOADINGTRUCK} alt="" />
                        </div>}
                    </div>

                    <div className="_prtRight_selctors">
                        <div>
                            <CustomSelect
                                label="Invoice Format"
                                options={formatList}
                                value={formats} // invoiceFormatDropdown?.find((i) => i?.value === invoiceFormats?.consignor_id?.invoice_format_id)
                                onSelect={(data) =>
                                    setFormats(data)
                                    // setFormatDetails(data)
                                }
                            />
                        </div>

                        {/* <div>
                            <CustomSelect
                                label="Number of Pages"
                                options={pageofPint}
                                value={pageofPint?.find((i) => i?.value === pageDetails)}
                                onSelect={(data) => setPageDetails(data?.value)}
                            />
                        </div> */}
                    </div>
                </div>
            </CommonModal>


        </>
    );
};

export default InvoicePrintModal;
